export const FILTER_MANAGERS = 'managers';
export const FILTER_APPLICATIONS = 'applications';
export const FILTER_NETWORKS = 'networks';

export const FILTER_YEAR = 'year';
export const FILTER_MONTH = 'month';
